interface Props {
  src: string | null;
  className?: string;
  fallback?: string;
  size?: "sm" | "md" | "lg" | "xl";
}

export default function Avatar({
  src,
  className = "",
  fallback = "👤",
  size = "md",
}: Props) {
  const isUrl = src?.startsWith("http");

  const sizeClasses = {
    sm: "w-6 h-6 text-base",
    md: "w-8 h-8 text-xl",
    lg: "w-10 h-10 text-2xl",
    xl: "w-20 h-20 text-5xl",
  };

  const containerClasses = `flex items-center justify-center shrink-0 rounded-full overflow-hidden select-none ${sizeClasses[size]} ${className}`;

  if (isUrl) {
    return (
      <div className={containerClasses}>
        <img
          src={src!}
          alt="Avatar"
          className="w-full h-full object-cover"
          onError={(e) => {
            // If image fails to load, fallback to default
            (e.target as HTMLImageElement).style.display = "none";
            (e.target as HTMLImageElement).parentElement!.innerText = fallback;
          }}
        />
      </div>
    );
  }

  return <div className={containerClasses}>{src || fallback}</div>;
}
